import React, { useEffect, useState } from 'react';
import AdminHeaderNew from '../NewAdminPanel/Common/AdminHeader';
import AdminSideBarNew from '../NewAdminPanel/Common/AdminSideBar';
import AdminFooterNew from '../NewAdminPanel/Common/AdminFooter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUsers } from "../../../node_modules/@fortawesome/free-solid-svg-icons/index";
import Circles from '../../assets/images/circle.png'


function Allocatedcase(){
    return(
        <>
          <AdminHeaderNew />
          <AdminSideBarNew />

          <main id="main" className="main">
        <div className="pagetitle">
          <h1>Allocated Case</h1>
          <nav>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">Admin</li>
              <li className="breadcrumb-item active">Dashboard</li>
            </ol>
          </nav>

     <section class="section dashboard asigntarget">
      <div className='row'>

      <div className="col-xxl-3 col-md-6">
   <div className="card info-card  sales-card bg-gradient-primary card-img-holder">

     <div className="card-body">
     <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
       <h5 className="card-title"> <span>Allocated Case</span></h5>

       <div className="d-flex align-items-center">
         <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
         <i><FontAwesomeIcon icon={faUsers} /> </i>
         </div>
         <div className="ps-3">
           <h6>70</h6>
           {/* <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

         </div>
       </div>
     </div>

   </div>
 </div>



 <div className="col-xxl-3 col-md-6">
   <div className="card info-card  sales-card bg-gradient-danger card-img-holder">

     <div className="card-body">
     <img src={Circles} className="card-img-absolute" alt="circle-image"/> 
       <h5 className="card-title"> <span>Total Case</span></h5>

       <div className="d-flex align-items-center">
         <div className="card-icon rounded-circle d-flex align-items-center justify-content-center">
         <i><FontAwesomeIcon icon={faUsers} /> </i>
         </div>
         <div className="ps-3">
           <h6>700</h6>
           {/* <span className="text-success small pt-1 fw-bold">5%</span> <span className="text-muted small pt-2 ps-1">increase</span> */}

         </div>
       </div>
     </div>

   </div>
 </div>

      </div>

  


<div class="row surveydetailsBg">
<div className='table-responsive allocated mt-3'>
<table class="table table-striped">
    <thead>
      <tr>
        <th>Sr.No</th>
        <th>Village</th>
        <th>Farmer Beneficiary</th>
        <th>Mobile No.</th>
        <th>Land Survey No.</th>
        <th>Survey Date</th>
        <th>Survey Name</th>
        <th>Survey Mobile</th>
        <th>Survey Code</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      <tr>
      <td>1.</td>
        <td>XYZ</td>
        <td>Doe</td>
        <td>99110098908</td>
        <td>789,690</td>
        <td>25-04-2025</td>
        <td>Akash Rana</td>
        <td>9900890789</td>
        <td>89076</td>
        <td><button type="button" class="btn btn-success"><i class="bi bi-check-circle"></i>  Verified</button></td>
      </tr>
      
      <tr>
      <td>2.</td>
        <td>XYZ</td>
        <td>ABC</td>
        <td>78910098908</td>
        <td>89,690</td>
        <td>26-04-2025</td>
        <td>Abay Rana</td>
        <td>8900890789</td>
        <td>19076</td>
        <td><button type="button" class="btn btn-danger"><i class="bi bi-x-circle"></i> Not Verified</button></td>
      </tr>

      <tr>
      <td>3.</td>
        <td>XYZ</td>
        <td>Doe</td>
        <td>99110098908</td>
        <td>789,690</td>
        <td>25-04-2025</td>
        <td>Akash Rana</td>
        <td>9900890789</td>
        <td>89076</td>
        <td><button type="button" class="btn btn-success"><i class="bi bi-check-circle"></i>  Verified</button></td>
      </tr>


    </tbody>
  </table>
</div>
</div>
</section>

        </div>
        </main>

          <AdminFooterNew />
    </>
    )
  
}

export default Allocatedcase;